import { useGoogleReCaptcha } from "react-google-recaptcha-v3";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { translationConstants } from "../../constants";

const useReCaptcha = (action = "default") => {
  const { t } = useTranslation();
  const { executeRecaptcha } = useGoogleReCaptcha();

  const handleReCaptchaVerify = async () => {
    try {
      if (!executeRecaptcha) {
        toast.error(t(translationConstants.RECAPTCHA_NOT_EXECUTED));
        return false;
      }
      const token = await executeRecaptcha(action);
      return true;
    } catch (error) {
      toast.error(t(translationConstants.RECAPTCHA_ERROR));
      return false;
    }
  };

  return handleReCaptchaVerify;
};

export default useReCaptcha;
